import { forwardRef } from 'react';

import { SvgStyled } from '@sternum/web/icons/icons.styles';
import { IconProps } from '@sternum/web/icons/icons.types';

export const UploadIcon = forwardRef<SVGSVGElement, IconProps>(function UploadIcon(
  { color = '', height = 12, width = 12, hasCursorPointer = false, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-has-cursor-pointer={hasCursorPointer}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.46943 0.192881C9.21263 -0.0642936 8.79625 -0.0642936 8.53944 0.192881L5.60227 3.13434C5.34548 3.39152 5.34548 3.80848 5.60227 4.06566C5.85908 4.32283 6.27543 4.32283 6.53222 4.06566L8.34682 2.2484V11.6341C8.34682 11.9978 8.64124 12.2927 9.00439 12.2927C9.36755 12.2927 9.66197 11.9978 9.66197 11.6341V2.24837L11.4766 4.06566C11.7334 4.32283 12.1498 4.32283 12.4066 4.06566C12.6633 3.80848 12.6633 3.39152 12.4066 3.13434L9.46943 0.192881ZM12.242 6.22155C12.2732 5.8592 12.5918 5.59075 12.9536 5.62194C14.63 5.76651 15.9428 6.28276 16.8141 7.358C17.6705 8.41504 18 9.89236 18 11.7307V11.8449C18 13.8725 17.5986 15.4633 16.5328 16.5307C15.4669 17.598 13.8785 18 11.8539 18H6.14612C4.12151 18 2.53302 17.598 1.4672 16.5307C0.401374 15.4633 0 13.8725 0 11.8449V11.7307C0 9.90571 0.325026 8.43735 1.16772 7.38241C2.02562 6.30846 3.31937 5.78538 4.9716 5.63115C5.33319 5.59738 5.65366 5.86358 5.68736 6.22571C5.72108 6.58784 5.45527 6.90877 5.09366 6.94253C3.64214 7.07804 2.74837 7.51204 2.19467 8.20519C1.62578 8.91738 1.31515 10.026 1.31515 11.7307V11.8449C1.31515 13.7422 1.69848 14.8997 2.39715 15.5993C3.09581 16.299 4.25159 16.6829 6.14612 16.6829H11.8539C13.7484 16.6829 14.9041 16.299 15.6028 15.5993C16.3015 14.8997 16.6849 13.7422 16.6849 11.8449V11.7307C16.6849 10.013 16.3698 8.90008 15.7928 8.18789C15.2305 7.49385 14.3208 7.06179 12.8408 6.93416C12.4789 6.90296 12.2109 6.58392 12.242 6.22155Z"
        fill={color || 'currentColor'}
      />
    </SvgStyled>
  );
});
